import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import Nav from './nav/';
import SubNav from './subNav/';

class corpNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { nav, subNav, subNavArea },
        } = this.props;

        return (
            <React.Fragment>
                <div className={styles.nav}>
                    <Chip id="50056" type="struct" title="主导航" groupName="导航栏" content={nav}>
                        <Nav />
                    </Chip>
                </div>

                <Chip id="200157" type="struct" title="副导航" groupName="导航栏" content={subNav}>
                    <SubNav subNavArea={subNavArea} />
                </Chip>
            </React.Fragment>
        );
    }
}

export default errorBoundary(corpNav);
